import { render, staticRenderFns } from "./CashbookEntryTemplates.vue?vue&type=template&id=12b6ab1a&"
import script from "./CashbookEntryTemplates.vue?vue&type=script&lang=ts&"
export * from "./CashbookEntryTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports